module.exports = __webpack_public_path__ + "static/media/sigla_alb.96928f46.png";